<template>
  <div id="Information" :style="{width:width}">
    <!-- 头部导航部分 -->
    <HomeHeader />
    <!-- banner -->
    <div style="padding-top:70px;width: 100%;margin: 0 auto;">
      <img src="@/assets/img/home/Information_banner.png" alt="" width="100%" height=""/>
    </div>
    <!-- 检索 -->
    <div class="search_body">
      <img src="@/assets/img/home/magnifier.png" alt="" width="400" height="280"/>
      <el-input class="search_input" v-model="searchString" placeholder="请输入关键词"></el-input>
      <button class="search_btn" @click="tosearch()">确认</button>
    </div>
    <!-- 内容 -->
    <div class="list_body">
      <ul>
        <li class="items" v-for="item in list" :key="item" @click="goNext(item.contentId)">
          <span class="red_dot" v-if="!item.isRead"></span>
          <img :src="item.simpleImgUrl + '?imageMogr2/quality/60'" alt="" width="400" height="280"/>
          <div class="list_item">
            <div class="item_title">{{item.title}}</div>
            <div class="item_content">{{item.description}}</div>
            <!-- <div class="item_content" v-html="item.content"></div> -->
          </div>
        </li>
      </ul>
      <div class="noData" v-if="pageinfo.totalCount === 0">暂无数据</div>
    </div>
    <!-- 分页 -->
    <div style="text-align: center;margin-top:96px;" v-if="pageinfo.totalCount !== 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="defaultPage"
        :page-size="9"
        layout="prev, pager, next"
        :total="pageinfo.totalCount">
      </el-pagination>
      <div style="font-size: 14px;display: inline-block;line-height: 28px;vertical-align: top;color:#999;">
        共{{pageinfo.totalCount}}条&nbsp;
        到第
        <input class="pageNum" v-model="pageNumber" type="number">
        页
        <el-button type="primary" style="font-size: 12px;" @click="changePage" class="professional_btn">确认</el-button>
      </div>
    </div>
    <!-- 底部组件 -->
    <HomeFooter style="margin-top: 78px;"/>
  </div>
</template>

<script>
import HomeHeader from '../../../components/HomeHeader'
import HomeFooter from '../../../components/HomeFooter'
import { getInformationList } from '@/api/modules/Information'
export default {
  name: 'Information',
  components: {
    HomeHeader,
    HomeFooter
  },
  data() {
    return {
      pageNumber: '',
      defaultPage: 1,
      searchString: '',
      list: [],
      pageinfo: {},
      pageIndex: 1
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList(searchString) {
      let obj = {}
      if (searchString === undefined || searchString === '') {
        obj = {
          pageIndex: this.pageIndex,
          pageSize: 9,
          groupId: '21813'
        }
      }
      else {
        obj = {
          title: searchString,
          groupId: '21813'
        }
      }
      const res = await getInformationList(obj)
      if (res.code === 0) {
        var arr = JSON.parse(localStorage.getItem('InformationArray'))
        if (arr === null) {
          arr = []
        }
        if (res.data.dataList !== undefined) {
          res.data.dataList.forEach(element => {
            const indexNum = arr.indexOf(element.contentId)
            if (indexNum > -1) {
              element.isRead = true
            }
            else {
              element.isRead = false
            }
          })
        }
        this.list = res.data.dataList
        this.pageinfo = res.data.page
      }
      else {
        this.$message({
          message: res.msg,
          type: 'error'
        })
        return
      }
    },
    handleSizeChange(val) {
      this.pageIndex = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getList()
    },
    changePage() {
      const maxPage = Math.ceil(this.pageinfo.totalCount / 9)
      if (this.pageNumber > maxPage) {
        this.pageNumber = maxPage
      }
      if (this.pageNumber === '') {
        this.pageIndex = 1
      }
      else {
        this.pageIndex = this.pageNumber
      }
      this.defaultPage = this.pageNumber
      this.getList()
    },
    goNext(id) {
      var arr = JSON.parse(localStorage.getItem('InformationArray'))
      if (arr === null) {
        arr = []
      }
      arr.push(id)
      window.localStorage.setItem('InformationArray', JSON.stringify(arr))
      this.$router.push({
        name: 'InformationDetail',
        query: {
          id: id
        }
      })
    },
    tosearch() {
      this.getList(this.searchString)
    }
  }
}
</script>

<style lang="less" scoped>
// 检索
.search_body{
  width:1340px;
  text-align: right;
  margin:0 auto;
  margin-top:28px;
  position: relative;
  .search_input{
    width: 270px !important;
    height: 40px;
    border-radius: 4px;
  }
  .search_btn{
    width: 70px;
    height: 40px;
    background: #5D82FF;
    border: 1px solid #4D78FF;
    border-radius: 4px;
    vertical-align: top;
    margin-left:10px;
    cursor:pointer;
    font-size: 14px;
    color: #EEF5FE;
    transition: all .2s;
  }
  .search_btn:hover{
    background:rgba(54,93,217);
  }
  img{
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    right: 322px;
    z-index: 99;
  }
}
/deep/.el-input__inner{
  padding-left:30px;
}
// 内容
.list_body{
  width:1340px;
  margin:0 auto;
  margin-top: 26px;
  ul{
    margin:0;
    padding:0;
  }
  ul li {
    list-style: none;
    width:400px;
    display: inline-block;
    background: #EAEAEA;
    margin-top:80px;
    transition: all .5s;
    position: relative;
    vertical-align: top;
    img{
      width:100%;
      vertical-align: middle;
    }
  }
}
.items:hover{
  background: #5D82FF;
  cursor:pointer;
  div{
    color:white;
  }
}
.list_body ul li:nth-child(1){
  margin-top: 0px;
}
.list_body ul li:nth-child(2){
  margin:0px 70px 0 70px;
}
.list_body ul li:nth-child(3){
  margin-top: 0px;
}
.list_body ul li:nth-child(5){
  margin: 80px 70px 0 70px;
}
.list_body ul li:nth-child(8){
  margin: 80px 70px 0 70px;
}
.list_item{
  text-align: center;
  .item_title{
    text-align:center;
    font-size: 18px;
    color: #333333;
    margin-top:34px;
    white-space : normal;
    transition: all .5s;
  }
  .item_content{
    width:304px;
    height:40px;
    line-height: 40px;
    overflow: hidden;
    margin:0 auto;
    font-size: 14px;
    color: #333333;
    margin-top:20px;
    margin-bottom: 26px;
    transition: all .5s;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}
// 分页
/deep/.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color:white ;
  background: #4D78FF;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
  background-color: #4D78FF;
  color: #FFF;
}
/deep/.el-pagination button:hover {
  color:white ;
  background: #4D78FF;
}
/deep/.el-pagination{
  display: inline-block;
  padding: 0;
  vertical-align: top;
}
/deep/.el-pager li{
  border: 1px solid #E5E5E5;
  border-radius: 4px !important;
  margin: 0 3px !important;
  font-weight: 400;
  color:#999999;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
  background: none;
}
.pageNum{
  width: 22px;
  height: 24px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  font-size: 14px;
}
.pageNum:focus {
  outline:none;
  border: 1px solid #E5E5E5;
}
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
}
input[type="number"]{
  -moz-appearance:textfield;
}
.professional_btn{
  width: 46px;
  height: 28px;
  background: #FFFFFF;
  border: 1px solid #4D78FF;
  border-radius: 4px;
  color: #4D78FF;
  padding: 0;
  transition: all .2s;
  font-size: 14px;
}
.professional_btn:hover{
  background: #4D78FF;
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
}
.noData{
  text-align: center;
  padding: 70px 0;
  line-height: 50px;
  font-size: 24px;
  color:#DDD;
}
.red_dot{
  display: inline-block;
  width:6px;
  height:6px;
  border-radius: 6px;
  background: red;
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>
